import React from "react";
import { Column, CellProps } from "react-table";
import { Dropdown } from "react-bootstrap";
import { ISharedConfig } from "components/features/types";
import Svg from "components/common/SVG/Svg";
import { BsToggleOn, BsToggleOff } from "react-icons/bs";

const ToggleOffIcon = BsToggleOff as any;
const ToggleOnIcon = BsToggleOn as any;

interface SharedConfigsColumnsProps {
  onEdit: (config: ISharedConfig) => void;
  onActivate: (config: ISharedConfig) => void;
  onDelete: (id: string, rowVersion: string) => void;
}

const renderBoolean = (value: boolean) => (
  <span className={`small ${value ? "text-success" : "text-muted"}`}>{value ? "Yes" : "No"}</span>
);

export const useSharedConfigsColumns = ({
  onEdit,
  onActivate,
  onDelete,
}: SharedConfigsColumnsProps): Column<any>[] => {
  return React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Used",
        accessor: "usedByTenantsCount",
      },
      {
        Header: "Active",
        accessor: "isEnabled",
        Cell: ({ value }) => renderBoolean(!!value),
      },
      {
        Header: "Actions",
        id: "actions",
        Cell: ({ row }: CellProps<ISharedConfig>) => {
          const { isEnabled } = row.original;
          return (
            <Dropdown>
              <Dropdown.Toggle
                className="no-caret btn btn-primary btn-sm"
                id={`dropdown-${row.original.id}`}
              >
                <Svg icon="threeDots" width={20} height={20} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => onEdit(row.original)}>
                  <Svg icon="pencil" width={15} height={15} />
                  <span className="ms-2">Edit</span>
                </Dropdown.Item>
                <Dropdown.Item onClick={() => onActivate(row.original)}>
                  {isEnabled ? (
                    <ToggleOffIcon size={15} style={{ color: "#dc3545" }} />
                  ) : (
                    <ToggleOnIcon size={15} style={{ color: "#28a745" }} />
                  )}
                  <span className="ms-2">{isEnabled ? "Deactivate" : "Activate"}</span>
                </Dropdown.Item>
                <Dropdown.Item onClick={() => onDelete(row.original.id, row.original.rowVersion)}>
                  <Svg icon="trash" width={15} height={15} />
                  <span className="ms-2">Delete</span>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          );
        },
      },
    ],
    [onEdit, onDelete],
  );
};
